module.exports = __webpack_public_path__ + "static/marc_2-6430d1f544f10af9e2003a20533b7672.gif";